<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
/* input[type=number] {
  -moz-appearance: textfield;
} */
</style>
    <a id="mbfs-header-login-cta" id="auto_trigger_forgot" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickForgot($event)" hidden></a>
     <!-- Forgot User -->
    <form [formGroup]="forgotForm" (ngSubmit)="prepareForgotUser($event)" *ngIf="openLoginModal && !forgotUser">
      <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
      [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
        <div class="mbfs-modal-overlay"></div>  
          <div class="mbfs-modal-content">  
              <h3 class="mbfs-modal-header">{{ 'LoginModal.ForgotUser' | translate }}</h3>
              <div class="mbfs-bank-profile-create-inner">   
                  <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                    <div class="form-group row s-2">
                      <div class="input-group">
                        <label for="email" style="text-align:left;" class="col-md-3 col-form-label">{{ 'LoginModal.NewEmail' | translate }}</label>
                        <input type="text" name="emailAddress" id="emailAddress" #email1 class="col-sm-6 form-control"
                        formControlName="emailAddress" required validateonblur
                        value="" autocomplete="off">
                      </div>
                    </div>
                  </div>
                  <p class="mbfs-passwordreset-p" >{{ 'LoginModal.EmailTip' | translate }}</p>
                  <br>
                  <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                    <div class="form-group row s-2">
                      <div class="input-group">
                        <label for="customerNumber" style="text-align:left;" class="col-md-3 col-form-label">{{ 'LoginModal.CustomerNumber' | translate }}</label>
                        <input type="text" name="customerNumber" id="customerNumber" class="col-sm-6 form-control" oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" 
                        formControlName="customerNumber" required validateonblur
                        value="" autocomplete="off">
                      </div>
                    </div>
                   </div>
                    <p class="mbfs-passwordreset-p" >{{ 'LoginModal.CustomerTip' | translate }}</p>
                  <br>
                  <!--Error Display to Modal View-->
                  <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
                    <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
                  </div>
                  <!--Spinner on Login Load-->
                  <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                    <div class="mbfs-loading-spinner-overlay"></div>
                    <div class="mbfs-loading-spinner"> </div>
                  </div>
              </div>
                <div class ="registrationlinks">
                  <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>                
                  <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event)">{{ 'LoginModal.Cancel' | translate }}</button>
                  <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
                    <br>
                </div>
          </div>
        </div>
    </form> 

    <!--If Email setup is successful show Email has been sent block -->
    <form *ngIf="openLoginModal && forgotUser">
      <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
      [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
          <div class="mbfs-modal-overlay"></div>  
          
          <div class="mbfs-modal-content"> 
            <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
            <div class="mbfs-bank-profile-create-inner"> 
              <div *ngIf="(!numAttempts && !userActive)">
                <div class ="registrationlinks">
                  <p class="mbfs-passwordreset-title" >{{ 'LoginModal.EmailSent' | translate }} {{this.emailAddress}} {{ 'LoginModal.EmailVerbiage1' | translate }}</p>
                  <p class="mbfs-passwordreset-p" >{{ 'LoginModal.RegisterVerbiage1' | translate }}</p>
                </div>
  
                <button type="submit" class="mbfs-button" [disabled]="!this.loginLoaded">{{ 'LoginModal.ResendLink' | translate }}</button>
                <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              </div>

              <div *ngIf="numAttempts">
                <div class ="registrationlinks">
                  <p class="mbfs-passwordreset-title" >{{ 'LoginModal.EmailSent' | translate }} {{this.emailAddress}} {{ 'LoginModal.EmailVerbiage1' | translate }}</p>
                  <p class="mbfs-passwordreset-p" >{{ 'LoginModal.Attempts' | translate }}</p>
                </div>
                <!--Spinner on Login Load-->
                <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
                </div>
                <button type="submit" class="mbfs-button" (click)="openRegistration($event)">{{ 'LoginModal.ReRegister' | translate }}</button>
                <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              </div>

              <div *ngIf="userActive">
                <div class ="registrationlinks">
                   <p class="mbfs-passwordreset-title" >{{ 'LoginModal.Success' | translate }}</p>
                </div>
                <!--Spinner on Login Load-->
                <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
                </div>
                <button type="submit" class="mbfs-button" (click)="openLogin($event)">{{ 'LoginModal.LogIn' | translate }}</button>
                <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              </div>
                <br>
            </div>      
          </div>
        </div>      
    </form> 

     